import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import FastCashPresenter from '../../../../../../presenters/FastCashPresenter';

const FormHeader = (props) => {
  const {
    onBlockDialogOpen,
    onUnblockAccount,
    fastCash,
    onShowLogsClick,
    isFlagUser,
    handleFlagUser,
    handleUnFlagUser,
  } = props;
  const userHasFastCash = !isNil(fastCash);
  const isBlocked = FastCashPresenter.isBlocked(fastCash);

  return (
    <div>
      <div className="form-header">
        <h2>FastCash</h2>
        <div className="form-header-actions">
          <input
            id="userFind"
            className="user-find-submit"
            type="submit"
            defaultValue="Find"
          />
          {userHasFastCash && (
            <button className="info-button" onClick={onShowLogsClick}>
              Show logs
            </button>
          )}
          {userHasFastCash &&
            (isFlagUser ? (
              <button
                className="button red-border -in-group"
                onClick={handleUnFlagUser}
              >
                Un-flag User
              </button>
            ) : (
              <button className="button red-border" onClick={handleFlagUser}>
                Flag User
              </button>
            ))}
          {userHasFastCash &&
            (isBlocked ? (
              <button className="button -in-group" onClick={onUnblockAccount}>
                Unblock account
              </button>
            ) : (
              <button className="button delete" onClick={onBlockDialogOpen}>
                Block account
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};

FormHeader.propTypes = {
  onBlockDialogOpen: PropTypes.func.isRequired,
  onUnblockAccount: PropTypes.func.isRequired,
  fastCash: PropTypes.shape(),
  onShowLogsClick: PropTypes.func.isRequired,
};
export default FormHeader;
